import { render, staticRenderFns } from "./CommentEmbeddedFormRead.vue?vue&type=template&id=0c8ba0f1&"
import script from "./CommentEmbeddedFormRead.vue?vue&type=script&lang=js&"
export * from "./CommentEmbeddedFormRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports